import React from 'react'
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles";

export default function InputPhone(props) {

    return (
        <div className='col-sm-6'>
            <div className="mb-20">
                <label
                    htmlFor="telefono"
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                    Teléfono {props.label} {props.required && <span className="text-danger-600">*</span>}
                </label>
                <div className='form-control radius-8'>
                    <IntlTelInput
                        initialValue={props.datos.telefono || ""}
                        onChangeCountry={props.onChangeCountry}
                        onChangeNumber={props.onChangePhone}
                        onChangeValidity={props.onChangeValidity}
                        initOptions={{
                            onlyCountries: ["mx", "us"],
                            initialCountry: props.datos.pais_telefono || "mx",
                        }}
                    />
                </div>
                {
                    props.error?.[props.name] && (
                        <div className="" style={{color: 'var(--danger-main)', fontSize: '15px',marginTop: '7px'}}>
                            {props.error?.[props.name]}
                        </div>
                    )
                }
            </div>
        </div>
    )
}
